import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, euro } from "@/lib/api";

export default function Products() {
  const [products, setProducts] = useState([]);
  const load = () => api.get("/admin/products").then(({ data }) => setProducts(data));
  useEffect(() => { load(); }, []);

  const save = async (p) => {
    await api.patch(`/admin/products/${p.gamme_key}`, {
      price_ttc: parseFloat(p.price_ttc), on_sale: p.on_sale,
      position_badge: p.position_badge, for_who: p.for_who,
    });
    toast.success(`${p.name} enregistré`); load();
  };
  const upd = (i, k, v) => setProducts(products.map((p, idx) => idx === i ? { ...p, [k]: v } : p));

  return (
    <div className="max-w-4xl">
      <h1 className="font-serif text-3xl font-bold text-brand-green mb-6">Produits</h1>
      <div className="space-y-4">
        {products.map((p, i) => (
          <div key={p.gamme_key} className="bg-white rounded-xl border border-brand-green/10 p-5" data-testid={`product-${p.gamme_key}`}>
            <div className="flex items-center justify-between mb-4">
              <h2 className="font-serif text-xl font-bold text-brand-green">{p.name}</h2>
              <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={p.on_sale} onChange={(e) => upd(i, "on_sale", e.target.checked)} className="accent-brand-green" data-testid={`onsale-${p.gamme_key}`} /> En vente</label>
            </div>
            <div className="grid sm:grid-cols-3 gap-3 items-end">
              <div>
                <label className="text-xs text-brand-green/60">Prix TTC (€)</label>
                <input data-testid={`price-${p.gamme_key}`} type="number" step="0.01" value={p.price_ttc} onChange={(e) => upd(i, "price_ttc", e.target.value)} className="w-full h-11 rounded-lg border border-brand-green/20 px-3" />
                <span className="text-xs text-brand-green/40">HT : {euro(p.price_ht)}</span>
              </div>
              <div>
                <label className="text-xs text-brand-green/60">Badge</label>
                <input value={p.position_badge} onChange={(e) => upd(i, "position_badge", e.target.value)} className="w-full h-11 rounded-lg border border-brand-green/20 px-3" />
              </div>
              <button data-testid={`save-product-${p.gamme_key}`} onClick={() => save(p)} className="h-11 rounded-lg bg-brand-gold text-brand-green font-semibold">Enregistrer</button>
            </div>
            <textarea value={p.for_who} onChange={(e) => upd(i, "for_who", e.target.value)} className="w-full mt-3 rounded-lg border border-brand-green/20 p-3 text-sm" rows={2} placeholder="Pour qui ?" />
            {Object.values(p.features || {}).some((v) => v === "à confirmer") && (
              <p className="text-xs text-brand-alert mt-2">⚠ Certaines caractéristiques sont « à confirmer » (affichées « n.c. » publiquement).</p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
